import { render } from "./QuestionnaireParent.vue?vue&type=template&id=ff8190dc&ts=true"
import script from "./QuestionnaireParent.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireParent.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src599522923/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__